export const ROUTE_ONBOARDING = '/onboarding'
export const ROUTE_WELCOME = '/welcome'
export const ROUTE_INTRO = '/introduction'

const ROOT = '/company-onboarding'

// company profile
export const ROUTE_COMPANY_PROFILE = `${ROOT}/profile`
export const ROUTE_COMPANY_PROFILE_OVERVIEW = `${ROUTE_COMPANY_PROFILE}/overview`
export const ROUTE_COMPANY_PROFILE_REGISTRATION_NUMBERS = `${ROUTE_COMPANY_PROFILE}/registration-numbers`

export const ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES = `${ROUTE_COMPANY_PROFILE}/legal-representatives`
export const ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES_BY_ID = `${ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES}/:externalId`
export const ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES_CREATE = `${ROUTE_COMPANY_PROFILE_LEGAL_REPRESENTATIVES}/create`

export const ROUTE_COMPANY_PROFILE_DIRECTORS = `${ROUTE_COMPANY_PROFILE}/directors`
export const ROUTE_COMPANY_PROFILE_DIRECTORS_BY_ID = `${ROUTE_COMPANY_PROFILE_DIRECTORS}/:externalId`
export const ROUTE_COMPANY_PROFILE_DIRECTORS_CREATE = `${ROUTE_COMPANY_PROFILE_DIRECTORS}/create`

export const ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS = `${ROUTE_COMPANY_PROFILE}/beneficial-owners`
export const ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS_BY_ID = `${ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS}/:externalId`
export const ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS_CREATE = `${ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS}/create`

export const ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS = `${ROUTE_COMPANY_PROFILE}/intermediary-shareholders`
export const ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS_BY_ID = `${ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS}/:externalId`
export const ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS_CREATE = `${ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS}/create`

export const ROUTE_COMPANY_PROFILE_BANK_DETAILS = `${ROUTE_COMPANY_PROFILE}/bank-details`
export const ROUTE_COMPANY_PROFILE_BANK_DETAILS_BY_ID = `${ROUTE_COMPANY_PROFILE_BANK_DETAILS}/:externalBankAccountId`
export const ROUTE_COMPANY_PROFILE_BANK_DETAILS_CREATE = `${ROUTE_COMPANY_PROFILE_BANK_DETAILS}/create`

export const ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS = `${ROUTE_COMPANY_PROFILE}/direct-debit-account`
export const ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS_BY_ID = `${ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS}/:externalBankAccountId`
export const ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS_CREATE = `${ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS}/create`

// company documents
export const ROUTE_COMPANY_DOCUMENTS = `${ROOT}/documents`
export const ROUTE_COMPANY_DOCUMENTS_LIST = `${ROUTE_COMPANY_DOCUMENTS}/company-documents`
export const ROUTE_COMPANY_FINANCIAL_DOCUMENTS = `${ROUTE_COMPANY_DOCUMENTS}/financial-documents`
export const ROUTE_COMPANY_GROUP_FINANCIAL_DOCUMENTS = `${ROUTE_COMPANY_DOCUMENTS}/group-financial-documents`
export const ROUTE_COMPANY_OTHER_DOCUMENTS = `${ROUTE_COMPANY_DOCUMENTS}/other-documents`

// Company Trade Partners
export const ROUTE_COMPANY_TRADE_PARTNERS = `${ROOT}/trade-partners`
export const ROUTE_COMPANY_TRADE_PARTNERS_BY_ID = `${ROUTE_COMPANY_TRADE_PARTNERS}/:externalId`
export const ROUTE_COMPANY_TRADE_PARTNERS_CREATE = `${ROUTE_COMPANY_TRADE_PARTNERS}/create`

export const ROUTE_CORPORATE_REPRESENTATIVES = `${ROOT}/corportate-representatives`
export const ROUTE_PAYMENT_INFORMATION = `${ROOT}/payment-information`
export const ROUTE_DOCUMENTS = `${ROOT}/documents`
